// marker object repository

import http from '../services/http'
import auth from '../services/auth'
import dates from '../services/dates'

const BASE_ROUTE = '/marker'

import Vue from 'vue'
const bus = new Vue()

export default {
  triggerFTPSync: function (markerId) {
    const baseUrl = markerId ? `${BASE_ROUTE}/${markerId}` : '/self_initiated_records'
    const url = `${baseUrl}/export/ftp/`
    return http.post(url, auth.getAuthHeader())
  },
  triggerFTPImagesSync: function () {
    return http.post('/self_initiated_records/export/ftp_images/', auth.getAuthHeader())
  },
  fetchTeamMarkers: function (teamId, page, pageSize) {
    // fetch a list markers for the provided team id
    let offset = (page - 1) * pageSize
    return http.get(`${BASE_ROUTE}/`, auth.getAuthHeader(), {team: teamId, offset: offset, limit: pageSize})
      .then(apiListToModels)
  },
  fetchMarkerDetails: function (markerId) {
    // fetch one marker object based on its id
    return http.get(`${BASE_ROUTE}/${markerId}/`, auth.getAuthHeader())
      .then(apiToModel)
  },
  save: function (marker) {
    // convert the model to the api format and save it to the backend
    const payload = modelToApi(marker)
    return http.post(`${BASE_ROUTE}/`, auth.getAuthHeader(), payload)
  },
  update: function (marker) {
    // convert the model to the api format and save it to the backend
    const payload = modelToApi(marker)
    return http.patch(`${BASE_ROUTE}/${marker.id}/`, auth.getAuthHeader(), payload)
  },
  delete: function (marker) {
    // delete a marker
    return http.delete(`${BASE_ROUTE}/${marker.id}/`, auth.getAuthHeader())
  },
  patch: function (markerId, updatedProps) {
    // partial updates on the marker model
    return http.patch(`${BASE_ROUTE}/${markerId}/`, auth.getAuthHeader(), updatedProps)
    .then((response) => {
      this.bus.$emit('marker-updated', markerId)
      return response
    })
  },
  bus: bus
}

// convert the internal frontend marker model to the backend api format
function modelToApi (marker) {
  const payload = {
    location: {
      type: 'Point',
      coordinates: [marker.position.long, marker.position.lat]
    },
    radius_meter: marker.radius,
    starts_at: dates.toApiFormat(marker.starts_at),
    reveal_at: dates.toApiFormat(marker.reveal_at),
    ends_at: dates.toApiFormat(marker.ends_at),
    brand: marker.brand,
    team: marker.team,
    ml_keyword: marker.ml_keyword,
    targeted_groups: marker.targeted_groups,
    is_push_forced: marker.is_push_forced,
    qwe: 'qeqe'
  }
  if (!payload.hasOwnProperty('translations')) {
    payload.translations = {}
  }
  // populate the api payload translations
  for (let prop of ['name', 'description', 'long_description']) {
    let field = marker[prop]
    Object.keys(field).forEach(function (locale) {
      if (field[locale]) {
        if (typeof payload.translations[locale] === 'undefined') {
          payload.translations[locale] = {}
        }
        payload.translations[locale][prop] = field[locale]
      }
    })
  }
  return payload
}

// convert {en: {description: "foo", long_description: ""},…}
// to: {description: {'en': 'foo', 'fr': 'bar'},…}
function apiTranslationsToModelField (translations, fieldname) {
  return Object.keys(translations).reduce(
    (result, locale) => {
      result[locale] = translations[locale][fieldname]
      return result
    }, {}
  )
}

// convert the backend api format to the internal frontend marker model
function apiToModel (payload) {
  const marker = {
    id: payload.id,
    starts_at: dates.parseDate(payload.starts_at),
    ends_at: dates.parseDate(payload.ends_at),
    reveal_at: payload.reveal_at && dates.parseDate(payload.reveal_at),
    info_link: payload.info_link,
    thanks_link: payload.thanks_link,
    brand: payload.brand,
    team: payload.team,
    position: {
      long: payload.location.coordinates[0],
      lat: payload.location.coordinates[1]
    },
    media: payload.media,
    radius: payload.radius_meter,
    is_active: payload.is_active,
    records_count: payload.records_count,
    ml_keyword: payload.ml_keyword,
    targeted_groups: payload.targeted_groups,
    name: apiTranslationsToModelField(payload.translations, 'name'),
    description: apiTranslationsToModelField(payload.translations, 'description'),
    long_description: apiTranslationsToModelField(payload.translations, 'long_description'),
    is_push_forced: payload.is_push_forced
  }
  return marker
}

// convert a backend response to a list of marker models
function apiListToModels (payload) {
  let result = payload['results'].map(apiToModel)
  result.count = payload['count']
  return result
}



// WEBPACK FOOTER //
// ./src/repositories/MarkerRepository.js